function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function setOrderCount(count) {
  if (count < 0) {
    count = 0;
  }
  window.order_count = count;
  localStorage.setItem('order_count', count);
}

function getOrderCount() {
  // console.log("SMRDTC-308 check:", window.order_count);
  // return parseInt(localStorage.getItem('order_count'));
  return window.order_count;
}

function validateOrderCount(messageSelector) {
  let currentOrderCount = getOrderCount();
  // console.log("SMRDTC-308 currentOrderCount", currentOrderCount);
  messageSelector.style.display = 'none';
  let validated = true;
  if (currentOrderCount >= 10) {
    messageSelector.style.display = 'block';
    validated = false;
  }
  return validated;
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function newGetDiscountValue(wrapper) {
  return {
    title: wrapper.querySelector('.title').textContent,
    value: wrapper.querySelector('.value').textContent,
  };
}

async function newUpdateDicounts() {
  const res = await fetch('/?render_id=header-minicart');
  const text = await res.text();
  const newhtml = document.createElement('div');
  newhtml.innerHTML = text;

  const newdiscounts = newhtml.querySelector('#cart-discounts');
  const olddiscounts = document.querySelector('#cart-discounts');
  const cartDiscounts = newdiscounts.querySelectorAll('.discount-cart');
  const productDiscounts = newdiscounts.querySelectorAll('.discount-product');
  let discountCodeValue = document.querySelector('#applied-discount-code .applied-discount-code-value');

  if (cartDiscounts.length > 0) {
    const discountValue = newGetDiscountValue(cartDiscounts[0]);
    discountCodeValue.innerHTML = discountValue.title + ' (-' + discountValue.value + ')';
  }
  if (productDiscounts.length > 0) {
    const discountValue = newGetDiscountValue(productDiscounts[0]);
    discountCodeValue.innerHTML = discountValue.title + ' (-' + discountValue.value + ')';
  }
  olddiscounts.innerHTML = newdiscounts.innerHTML;
}

document.addEventListener('cart-update', () => {
  setTimeout(() => {
    newUpdateDicounts();
  }, 2500);
});

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', {
      bubbles: true,
    });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    setTimeout(() => {
      newUpdateDicounts();
    }, 2500);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
    this.setViewportHeight();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    window.addEventListener('resize', this.setViewportHeight);
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const iconPlus = summaryElement.querySelector('.icon-plus');
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open') || detailsElement.classList.contains('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const subMenu = detailsElement.children[1];

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling);
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      if (isOpen) {
        this.closeSubmenu(detailsElement);
      } else {
        detailsElement.classList.add('open');
        summaryElement.setAttribute('aria-expanded', true);
        iconPlus?.classList.add('hidden');
        parentMenuElement?.classList.add('submenu-open');
        subMenu?.classList.add('open');
        reducedMotion?.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }
    }
  }

  setViewportHeight() {
    if (window.matchMedia('(max-width: 990px)')) {
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    document.body.classList.add('overflow-hidden');
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('.details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('open');
    });
    this.mainDetailsToggle.querySelectorAll('.menu-drawer__submenu').forEach((submenu) => {
      submenu.classList.remove('open');
    });
    this.mainDetailsToggle.querySelectorAll('.icon-plus').forEach((iconplus) => {
      iconplus.classList.remove('hidden');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    const iconPlus = detailsElement.querySelector('.icon-plus');
    const subMenu = detailsElement.children[1];
    iconPlus?.classList.remove('hidden');
    subMenu?.classList.remove('open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('open');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    // this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      // Updating dots
      const sliderDots = document.querySelectorAll('.mobile.thumbnail-slider > ul li button');
      sliderDots.forEach((item) => {
        item.removeAttribute('aria-current');
      });
      if (sliderDots.length > 0) {
        sliderDots[this.currentPage - 1].ariaCurrent = true;
        this.dispatchEvent(
          new CustomEvent('slideChanged', {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          })
        );
      }
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;
    this.isInfiniteScrolling = false; // Flag to prevent interference during infinite scroll

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    // Initialize responsive slide filtering for announcement bar
    if (this.announcementBarSlider) {
      this.initResponsiveSlides();
      // Debounce resize handler to avoid too many calls
      this.resizeTimeout = null;
      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
          this.initResponsiveSlides();
        }, 250);
      });
    }

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          {
            once: true,
          }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  initResponsiveSlides() {
    if (!this.announcementBarSlider) return;
    
    const isMobile = window.innerWidth < 768;
    const allSlides = this.querySelectorAll('[id^="Slide-"]');
    
    // Filter slides based on viewport
    this.activeSlides = Array.from(allSlides).filter(slide => {
      const isHiddenOnDesktop = slide.classList.contains('no-desk');
      const isHiddenOnMobile = slide.classList.contains('no-mob');
      
      if (isMobile && isHiddenOnMobile) return false;
      if (!isMobile && isHiddenOnDesktop) return false;
      
      return true;
    });
    
    // If no slides are visible, hide the entire announcement bar
    if (this.activeSlides.length === 0) {
      const announcementBarSection = this.closest('.announcement-bar-section');
      if (announcementBarSection) {
        announcementBarSection.style.display = 'none';
      }
      return;
    } else {
      // Show announcement bar if it was hidden
      const announcementBarSection = this.closest('.announcement-bar-section');
      if (announcementBarSection) {
        announcementBarSection.style.display = '';
      }
    }
    
    // Update sliderItems to only include active slides
    this.sliderItems = this.activeSlides;
    
    // Hide/show slides based on current viewport
    allSlides.forEach(slide => {
      if (this.activeSlides.includes(slide)) {
        slide.style.display = '';
        slide.removeAttribute('aria-hidden');
      } else {
        slide.style.display = 'none';
        slide.setAttribute('aria-hidden', 'true');
      }
    });
    
    // Reset to first active slide if current slide is now hidden
    if (this.activeSlides.length > 0) {
      const currentSlideStillActive = this.activeSlides.some((slide, index) => index === this.currentPage - 1);
      if (!currentSlideStillActive) {
        this.currentPage = 1;
        this.slider.scrollLeft = 0;
      }
      
      // Hide navigation buttons if only one slide is active
      const prevButton = this.querySelector('.slider-button--prev');
      const nextButton = this.querySelector('.slider-button--next');
      if (this.activeSlides.length <= 1) {
        if (prevButton) prevButton.style.display = 'none';
        if (nextButton) nextButton.style.display = 'none';
      } else {
        if (prevButton) prevButton.style.display = '';
        if (nextButton) nextButton.style.display = '';
      }
    }
    
    // Reinitialize slider if we have active slides
    if (this.activeSlides.length > 0) {
      this.initPages();
    }
  }

  initPages() {
    // For announcement bar, use filtered active slides
    if (this.announcementBarSlider && this.activeSlides) {
      this.sliderItemsToShow = this.activeSlides.filter((element) => element.clientWidth > 0);
    } else {
      // Default behavior for other sliders
      this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    }
    
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const activeSlides = this.activeSlides || this.sliderItems;
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === activeSlides.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    // Handle infinite scroll smoothly
    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.smoothInfiniteScroll('previous');
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.smoothInfiniteScroll('next');
    } else {
      this.setSlidePosition(this.slideScrollPosition);
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
    }
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    
    // For announcement bar, use immediate positioning during infinite scroll
    if (this.announcementBarSlider && this.isInfiniteScrolling) {
      this.slider.scrollTo({
        left: position,
      });
      return;
    }
    
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  smoothInfiniteScroll(direction) {
    if (!this.announcementBarSlider) return;

    const currentIndex = this.currentPage - 1;
    const itemsCount = this.activeSlides ? this.activeSlides.length : this.sliderItems.length;
    
    if (direction === 'next') {
      // Going from last to first
      const nextIndex = 0;
      this.performSmoothTransition(currentIndex, nextIndex, direction);
    } else {
      // Going from first to last
      const nextIndex = itemsCount - 1;
      this.performSmoothTransition(currentIndex, nextIndex, direction);
    }
  }

  performSmoothTransition(currentIndex, nextIndex, direction) {
    const activeSlides = this.activeSlides || this.sliderItems;
    const currentSlide = activeSlides[currentIndex];
    const nextSlide = activeSlides[nextIndex];
    
    // Set flag to prevent interference during transition
    this.isInfiniteScrolling = true;
    
    // Apply fade animation
    this.applyAnimationToAnnouncementBar(direction);
    
    // Update the current page and scroll position smoothly
    setTimeout(() => {
      // Update current page first
      if (direction === 'next') {
        this.currentPage = 1;
      } else {
        this.currentPage = activeSlides.length;
      }
      
      // Calculate the correct scroll position
      const targetScrollPosition = direction === 'next' ? 0 : 
        this.sliderFirstItemNode.clientWidth * (activeSlides.length - 1);
      
      // Set the scroll position immediately without animation
      this.slider.scrollLeft = targetScrollPosition;
      
      // Update the visual indicators
      this.updateControlsAfterInfiniteScroll();
      
      // Clear the flag after a short delay to ensure everything is settled
      setTimeout(() => {
        this.isInfiniteScrolling = false;
      }, 50);
    }, this.announcerBarAnimationDelay);
  }

  updateControlsAfterInfiniteScroll() {
    // Update slider controls without triggering the full update cycle
    const sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    if (sliderControlButtons.length > 0) {
      sliderControlButtons.forEach((link) => {
        link.classList.remove('slider-counter__link--active');
        link.removeAttribute('aria-current');
      });
      sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }
    
    // Update page counter
    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
    }
  }

  update() {
    // Prevent updating during infinite scroll transitions
    if (this.isInfiniteScrolling) return;
    
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const activeSlides = this.activeSlides || this.sliderItems;
    const isLastSlide = this.currentPage === activeSlides.length;
    
    if (isLastSlide) {
      // Use smooth infinite scroll for auto-rotation
      this.smoothInfiniteScroll('next');
    } else {
      // Normal slide progression
      const slideScrollPosition = this.slider.scrollLeft + this.sliderItemOffset;
      this.setSlidePosition(slideScrollPosition);
      this.applyAnimationToAnnouncementBar();
    }
  }

  setSlideVisibility(event) {
    const slidesToShow = this.announcementBarSlider && this.activeSlides ? this.activeSlides : this.sliderItemsToShow;
    
    slidesToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const activeSlides = this.activeSlides || this.sliderItems;
    const itemsCount = activeSlides.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = activeSlides[nextIndex];
    const currentSlide = activeSlides[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    // Determine direction for smooth infinite scroll
    let direction;
    if ((button === 'next' && isLastSlide) || (button === 'previous' && isFirstSlide)) {
      // Infinite scroll cases - maintain visual direction
      direction = button;
    } else {
      // Normal cases
      const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
      direction = shouldMoveNext ? 'next' : 'previous';
    }

    // Apply animation classes
    if (currentSlide) {
      currentSlide.classList.add(`${animationClassOut}-${direction}`);
    }
    if (nextSlide) {
      nextSlide.classList.add(`${animationClassIn}-${direction}`);
    }

    // Clean up animation classes
    setTimeout(() => {
      if (currentSlide) {
        currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      }
      if (nextSlide) {
        nextSlide.classList.remove(`${animationClassIn}-${direction}`);
      }
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.selectDefaultVariant();
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    // this.updateSelectedSwatchValue(event);
    // this.toggleAddButton(true, '', false);
    // this.updatePickupAvailability();
    // this.removeErrorMessage();
    // this.updateVariantStatuses();

    if (!this.currentVariant) {
      // this.toggleAddButton(true, '', true);
      // this.setUnavailable();
    } else {
      const pdpVariantIdInput = document.getElementById('variant-id-input');
      pdpVariantIdInput.value = this.currentVariant.id;
      // this.updateMedia();
      // this.updateURL();
      // this.updateVariantInput();
      // this.renderProductInfo();
      // this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  selectDefaultVariant() {
    this.currentVariant = JSON.parse(document.querySelector('variant-selects [data-selected-variant]')?.innerHTML);
    if (this.currentVariant) {
      const pdpVariantIdInput = document.getElementById('variant-id-input');
      pdpVariantIdInput.value = this.currentVariant.id;
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(document.querySelector('variant-selects [data-variants]')?.innerHTML);
    return this.variantData;
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(
        new Event('change', {
          bubbles: true,
        })
      );
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// ADD TO CART BUTTON STARTS

document.addEventListener('DOMContentLoaded', () => {
  const variantOptionsFBID = document.querySelectorAll('[data-variant-fbid]');
  const variantOptionsID = document.querySelectorAll('[data-id]');
  const variantIdInput = document.getElementById('variant-id-input');
  const priceContainer = document.querySelectorAll('.dynamic-price');
  const mf = window?.sm_theme?.variable?.money_format || '{{amount}}';
  const mysteryBox = document.querySelector('.dynamic-mystery-box');

  variantOptionsFBID.forEach((option) =>
    option.addEventListener('click', () => {
      const variantId = option.dataset.variantFbid;
      const form = option.closest('form');
      if (form && form.querySelector('#variant-id-input')) {
        form.querySelector('#variant-id-input').value = variantId;
      }
      const selectedVariant = window.productVariants.find((v) => v.id == variantId);
      const { name, price } = selectedVariant || {};
      if(name?.toLowerCase()?.includes('gift card') && mf)
      {
        let newPrice = Shopify.formatMoney(price, mf).replace('CAD', '').replace('.00', '');
        if (Shopify.country === 'GB') {
          newPrice = newPrice.replace('$', '');
        } else {
        if (!newPrice.includes('$')) {
          newPrice = '$' + newPrice;
        }
      }
        priceContainer.forEach((price) => { price.innerHTML = newPrice });
      }
      if (mysteryBox) {
        const value = option.getAttribute('data-value');
        mysteryBox.textContent = value;
      }
    })
  );

  variantOptionsID.forEach((option) =>
    option.addEventListener('click', () => {
      if (!variantIdInput.value) {
        const variantId = option.dataset.id;
        variantIdInput.value = variantId;
        const selectedVariant = window.productVariants.find((v) => v.id == variantId);
        const { name, price } = selectedVariant || {};
        if(name?.toLowerCase()?.includes('gift card') && mf)
        {
          const newPrice = Shopify.formatMoney(price, mf).replace('CAD', '').replace('.00', '');
          priceContainer.forEach((price) => { price.innerHTML = newPrice });
        }
      }
    })
  );

  function closePopup() {
    $('.popupBox').removeClass('slideInDown');
    $('.popupBox').addClass('slideOutUp');
    $('.popupOverlay').fadeOut('slow');
    $('.rebooted_popup')?.removeClass('active');
  }

  const urlParams = new URLSearchParams(window.location.search);
  const isInApp = ((urlParams.get('app') || '').trim().toLowerCase()).startsWith('kinn');

  function addKinnClass(){
    const el = document.getElementById('sticky-nav-header-mobile');
    if (el) el.classList.add('is-kinn');
  }

  if (isInApp) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', addKinnClass);
    } else {
      addKinnClass();
    }
  }

  $('body').on('submit', 'form[action="/cart/add"]', async function (e) {
    e.preventDefault();
    $('.error').remove();
    
    const isFromApp =
    new URLSearchParams(window.location.search).get('app') === 'kinn' ||
    localStorage.getItem('isKinn') === 'true';

    if (isFromApp && localStorage.getItem('sourceSaved') !== 'true') {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              source: 'app'
            }
          })
        });
        localStorage.setItem('isKinn', 'true');
        localStorage.setItem('sourceSaved', 'true');
      } catch (err) {
      }
    }

    var $addToCartForm = $(this);
    var $addToCartBtn = $addToCartForm.find('[type="submit"]');
    var $buttonText = $addToCartBtn.text();
    $addToCartBtn.text(window.cartStrings.adding);
    $addToCartBtn.addClass('disabled').prop('disabled', true);
    var variantId = $addToCartForm.find('input[name="id"]').val();
    var barcode = '';
    var formData = $addToCartForm.serialize();
    if (window.productVariants && variantId) {
      const selectedVariant = window.productVariants.find((v) => v.id == variantId);
      barcode = selectedVariant ? selectedVariant.barcode : '';
      formData = formData + '&properties[UPC]=' + barcode;
    }

    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: formData,
      success: function (itemData) {
        const widgetScript = document.createElement('script');
        const dataBrand = document.querySelector('html')?.getAttribute('data-brand');
        if (dataBrand) {
          widgetScript.src =
            'https://static-recommendations.fastsimon.com/no-code-recommendations/fs-recommendations-init.js?uuid=' +
            window.FS_UUID +
            '&store_id=' +
            window.FS_STORE_ID +
            '&platform=Shopify&widgetId=' +
            window.FS_WIDGET_ID +
            '&v=' +
            Date.now();
        }
        document.head.appendChild(widgetScript);
        $addToCartBtn.addClass('inverted');
        $addToCartBtn.text(window.cartStrings.added);

        closePopup();
        document.dispatchEvent(new CustomEvent('swym:button-loaded'));
        updatecart().then(function () {
          document.querySelector('cart-drawer').open();
          $addToCartBtn.prop('disabled', false).removeClass('disabled').removeClass('inverted');
          $addToCartBtn.text($buttonText);
          $addToCartBtn.removeClass('disabled').prop('disabled', false);
        });
        const isBackOrder = itemData.properties != null ? itemData.properties['Back-ordered items'] != null : false;
        const isPreOrder = itemData.properties != null ? itemData.properties['Pre-ordered items'] != null : false;
        var expectedShipDate =
          itemData.properties != null
            ? itemData.properties['EXPECTED SHIP DATE'] != null
              ? itemData.properties['EXPECTED SHIP DATE']
              : ''
            : '';
        var expectedToShip =
          itemData.properties != null
            ? itemData.properties['EXPECTED TO SHIP'] != null
              ? itemData.properties['EXPECTED TO SHIP']
              : ''
            : '';
        var size = itemData.variant_options.length > 1 ? itemData.variant_options[1].trim() : '';
        window.dataLayer = window.dataLayer || [];
        var dlProduct = {
          id: itemData.product_id,
          sku: itemData.variant_id,
          style: itemData.sku,
          name: itemData.title,
          price: (parseInt(itemData.final_price) / 100).toFixed(2),
          basePrice: (parseInt(itemData.original_price) / 100).toFixed(2),
          quantity: itemData.quantity,
          brand: itemData.vendor,
          color: itemData.variant_options[0].trim(),
          colorFamily: itemData.variant_options[0].trim(),
          size: size,
          expectedShipDate: expectedShipDate,
          upc: barcode,
        };
        window.dataLayer.push({
          event: 'addToCart',
          addToCart: {
            products: [dlProduct],
            IsPreOrder: isPreOrder,
            IsBackOrder: isBackOrder,
            expectedShipDate: expectedShipDate || expectedToShip,
            addToCartLocation: window.addToCartLocationOverride || 'Product Page',
          },
          _clear: true,
        });
        window.dataLayer.push({
          event: 'viewedSideCart',
          _clear: true,
        });

        if (window.enabled_max_units) {
          let currentOrderCount = getOrderCount();
          setOrderCount(currentOrderCount + 1);
        }

        try {
          var map = JSON.parse(localStorage.getItem('sm_rm_meta') || '{}');
          map[itemData.variant_id] = {
            ...(map[itemData.variant_id] || {}),
            upc: barcode || (itemData.properties && (itemData.properties.UPC || itemData.properties['UPC'])) || '',
            expectedShipDate: (expectedShipDate || expectedToShip || ''),
            isPreOrder: !!isPreOrder,
            isBackOrder: !!isBackOrder,
            price: price,
            basePrice: basePrice
          };
          localStorage.setItem('sm_rm_meta', JSON.stringify(map));
        } catch(e){}

      },
      error: function (XMLHttpRequest) {
        var response = $.parseJSON(XMLHttpRequest.responseText);
        $addToCartForm
          .append('<p class="error">' + response.description + '</p>')
          .find('.error')
          .fadeIn()
          .delay(4000)
          .fadeOut();
        $addToCartBtn.text($buttonText);
        $addToCartBtn.removeClass('disabled').prop('disabled', false);
      },
    });
  });
  const openCartDrawer = localStorage.getItem('openCartDrawer');
  if (openCartDrawer === 'true' && document.querySelector('cart-drawer')) {
    document.querySelector('cart-drawer').open();
    localStorage.removeItem('openCartDrawer');
  }

  // Disable button and set text to "Out of Stock" if data-avaiable is false
  const variantAvailability = document.querySelector('[data-avaiable]');
  if (variantAvailability) {
    if (variantAvailability.dataset.avaiable === 'false') {
      const addToCartButton = document.getElementById('add-to-cart-button');
      if (addToCartButton) {
        addToCartButton.disabled = true;
        addToCartButton.innerText = 'Out of Stock';
      }
    }
  }

  setTimeout(() => {
    document.querySelectorAll('div.r-pdp-accordion a').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        window.location.href = link.href;
      });
    });
  }, 3000);

  (function hydrateCartPriceCache(){
    fetch('/cart.js', {credentials:'same-origin'})
      .then(r => r.ok ? r.json() : null)
      .then(c => {
        if (!c || !Array.isArray(c.items)) return;
        let map;
        try { map = JSON.parse(localStorage.getItem('sm_rm_meta') || '{}'); }
        catch(e){ map = {}; }
        let changed = false;
  
        c.items.forEach(li => {
          const vid  = li.variant_id;
          const base = Number(li.original_price || li.compare_at_price || li.price || 0)/100;
          const fin  = Number(li.final_price    || li.price            || 0)/100;
          const upc  = (li.properties && (li.properties.UPC || li.properties['UPC'])) || (map[vid] && map[vid].upc) || '';
          const esd  = (li.properties && (li.properties['EXPECTED SHIP DATE'] || li.properties['EXPECTED TO SHIP'])) || (map[vid] && map[vid].expectedShipDate) || '';
  
          map[vid] = {
            ...(map[vid] || {}),
            basePrice: base.toFixed(2),
            price:     fin.toFixed(2),
            upc:       upc,
            expectedShipDate: esd
          };
          changed = true;
        });
  
        if (changed) localStorage.setItem('sm_rm_meta', JSON.stringify(map));
      })
      .catch(()=>{});
  })();
  
  (function(){
    // --- h ---
    const dl = window.dataLayer = window.dataLayer || [];
    const toMoney = c => (Number(c||0)/100).toFixed(2);
  
    function getMeta(variantId){
      try { return JSON.parse(localStorage.getItem('sm_rm_meta')||'{}')[variantId] || {}; }
      catch(e){ return {}; }
    }
  
    // return variant
    function fetchVariantByUrl(url, variantId){
      const clean = String(url||'').replace(/\?.*$/, '');
      if (!clean) return Promise.resolve(null);
      return fetch(clean + '.js', {credentials:'same-origin'})
        .then(r => r.ok ? r.json() : Promise.reject())
        .then(prod => (prod.variants||[]).find(v => Number(v.id) === Number(variantId)) || null)
        .catch(()=>null);
    }
  
    function enrichRemovedItem(it){
      const meta = getMeta(it.variant_id);
      return fetchVariantByUrl(it.url, it.variant_id).then(v => {
        let priceCents = Number(it.presentment_price ?? it.price ?? 0) * (String(it.price).includes('.') ? 100 : 1);
        let baseCents  = priceCents;
  
        if (v) {
          const vp  = Number(v.price || 0);
          const vca = Number(v.compare_at_price || 0);
          if (vca > vp) { baseCents = vca; priceCents = vp; }
          else { baseCents = vp; priceCents = vp; }
        }
  
        return {
          id: it.product_id,
          sku: it.variant_id,
          style: it.sku || it.product_title || '',
          name: it.product_title || it.title || '',
          price:     toMoney(priceCents),
          basePrice: toMoney(baseCents),
          quantity: Number(it.quantity || 1),
          brand: (it.vendor || '').toUpperCase().replace(/\s+/g,''),
  
          ...(() => {
            const parts = String(it.variant_title||'').split(' / ').map(s=>s.trim());
            const color = parts[0] || '';
            const size  = parts[1] || '';
            return { color, colorFamily: color, size };
          })(),
          expectedShipDate: meta.expectedShipDate || '',
          upc: meta.upc || ''
        };
      });
    }
  
    function enrichCartItem(li){
      return fetchVariantByUrl(li.url, li.variant_id).then(v => {
        let priceCents = Number(li.final_price ?? li.price ?? 0);
        let baseCents  = Number(li.original_price || li.compare_at_price || li.price || 0);
  
        if (v) {
          const vp  = Number(v.price || 0);
          const vca = Number(v.compare_at_price || 0);
          if (vca > vp) { baseCents = vca; priceCents = vp; }
          else { baseCents = vp; priceCents = vp; }
        }
  
        return {
          id: li.product_id,
          sku: li.variant_id,
          style: li.sku || li.product_title || '',
          name: li.product_title || li.title || '',
          price:     toMoney(priceCents),
          basePrice: toMoney(baseCents),
          quantity: li.quantity,
          brand: (li.vendor || '').toUpperCase().replace(/\s+/g,''),
          color: (li.options_with_values||[]).find(o=>/color/i.test(o.name))?.value || '',
          colorFamily: (li.options_with_values||[]).find(o=>/color/i.test(o.name))?.value || '',
          size: (li.options_with_values||[]).find(o=>/size/i.test(o.name))?.value || '',
          expectedShipDate: (li.properties?.['EXPECTED SHIP DATE'] || li.properties?.['EXPECTED TO SHIP'] || ''),
          upc: (li.properties?.UPC || li.properties?.['UPC'] || '')
        };
      });
    }
  
    function getEnrichedCart(){
      return fetch('/cart.js', {credentials:'same-origin'})
        .then(r => r.ok ? r.json() : Promise.reject())
        .then(json => {
          const items = Array.isArray(json.items) ? json.items : [];
          return Promise.all(items.map(enrichCartItem)).then(products => ({
            total:  (Number(json.total_price||0)/100).toFixed(2),
            count:  json.item_count || 0,
            products
          }));
        })
        .catch(()=>null);
    }
  
    function pushRemoveAsync(json){
      if (!json) return;
      const removedArr = Array.isArray(json.items_removed) ? json.items_removed : [];
      const cartArr = Array.isArray(json.items) ? json.items : [];
  
      if (!removedArr.length) return;
  
      Promise.all([
        Promise.all(removedArr.map(enrichRemovedItem)),
        Promise.all(cartArr.map(enrichCartItem))
      ]).then(([removed, cartItems]) => {
        const meta0 = removed && removed[0] ? getMeta(removed[0].sku) : {};
  
        dl._origPush({
          event: 'removeFromCart',
          removeFromCart: {
            products: removed,
            IsPreOrder: !!meta0.isPreOrder,
            IsBackOrder: !!meta0.isBackOrder,
            expectedShipDate: removed[0]?.expectedShipDate || '',
            RemoveFromCartLocation: (location.pathname.indexOf('/cart') === 0) ? 'Cart Page' : 'Sidecart'
          },
          cart: {
            total:  (Number(json.total_price||0)/100).toFixed(2),
            count:  json.item_count || 0,
            products: cartItems
          },
          _clear: true
        });
      }).catch(err => {
        console.error('pushRemoveAsync error:', err);
      });
    }

    let __prevCartSnapshot = null;

    function snapshotCartState(json){
      if (!json || !Array.isArray(json.items)) { __prevCartSnapshot = null; return; }
      __prevCartSnapshot = (json.items || []).map(it => ({
        variant_id: it.variant_id,
        quantity: it.quantity,
        url: it.url,
        product_id: it.product_id,
        price: it.price,
        final_price: it.final_price,
        original_price: it.original_price,
        compare_at_price: it.compare_at_price,
        options_with_values: it.options_with_values,
        properties: it.properties,
        vendor: it.vendor,
        sku: it.sku,
        product_title: it.product_title,
        title: it.title
      }));
    }

    function computeIncreases(prev, curr){
      if (!prev || !curr) return [];
      const byVarPrev = new Map(prev.map(p => [p.variant_id, p]));
      const inc = [];
      for (const li of (curr.items || [])) {
        const before = byVarPrev.get(li.variant_id);
        const prevQty = before ? Number(before.quantity||0) : 0;
        const nowQty  = Number(li.quantity||0);
        const delta = nowQty - prevQty;
        if (delta > 0) {
          inc.push({ ...li, quantity: delta });
        }
      }
      return inc;
    }

    async function pushAddDeltaIfAny(prevJson, currJson){
      const addedLines = computeIncreases(prevJson, currJson);
      if (!addedLines.length) return;

      const products = await Promise.all(addedLines.map(enrichCartItem));

      const meta0 = products[0] ? getMeta(products[0].sku) : {};

      // const AddToCartLocation = (location.pathname.indexOf('/cart') === 0) ? 'Cart Page' : 'Sidecart';
      const AddToCartLocation = consumeATCLocation() || ((location.pathname.indexOf('/cart') === 0) ? 'Cart Page' : 'Sidecart');

      const cartObj = {
        total:  (Number(currJson.total_price||0)/100).toFixed(2),
        count:  currJson.item_count || 0,
        products: await Promise.all((currJson.items||[]).map(enrichCartItem))
      };

      window.dataLayer._origPush({
        event: 'addToCart',
        addToCart: {
          products,
          IsPreOrder: !!meta0?.isPreOrder,
          IsBackOrder: !!meta0?.isBackOrder,
          expectedShipDate: products[0]?.expectedShipDate || '',
          AddToCartLocation
        },
        cart: cartObj,
        _clear: true,
        __cart_augmented__: true
      });
    }

    let __deltaLock = false;

    function takeSnapshot() {
      return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(r => r.json())
        .then(prev => snapshotCartState(prev))
        .catch(() => { __prevCartSnapshot = null; });
    }

    // FETCH
    const _fetch = window.fetch;
    window.fetch = function(input, init){
      const url = typeof input === 'string' ? input : (input?.url || '');
      const method = (init?.method || 'GET').toUpperCase();
      // const watch  = method !== 'GET' && /\/cart\/(change|update)(?:\.js)?(?:\?|$)/i.test(url);
      const watch  = method !== 'GET' && /\/cart\/(add|change|update)(?:\.js)?(?:\?|$)/i.test(url);
      const isAdd  = method !== 'GET' && /\/cart\/add(?:\.js)?(?:\?|$)/i.test(url);

      if (watch && !__deltaLock) { __deltaLock = true; takeSnapshot(); }

      const p = _fetch.apply(this, arguments);
      if (!watch) return p;

      return p.then(async resp => {
        try {
          const text = await resp.clone().text();
          // const json = JSON.parse(text || '{}');

          let json = {};
          if (isAdd) {
            json = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(r => r.json());
          } else {
            json = JSON.parse(text || '{}');
          }

          pushRemoveAsync(json);

          try { await pushAddDeltaIfAny(__prevCartSnapshot, json); } catch(e){}
        } catch(e) {}
        __prevCartSnapshot = null; __deltaLock = false;
        return resp;
      });
    };

    function consumeATCLocation(){
      const loc = window.__ff_atc_origin;
      if (loc) { try { delete window.__ff_atc_origin; } catch(e){ window.__ff_atc_origin = null; } }
      return loc || null;
    }

    // XHR
    const _open = XMLHttpRequest.prototype.open;
    const _send = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url){
      this.__rc = { method: (method||'GET').toUpperCase(), url: url||'' };
      return _open.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function(body){
      const info = this.__rc || {};
      const watch = info.method !== 'GET' && /\/cart\/(change|update)(?:\.js)?(?:\?|$)/i.test(info.url);

      if (watch && !__deltaLock) { __deltaLock = true; takeSnapshot(); }

      if (watch) {
        this.addEventListener('loadend', async () => {
          try {
            // const json = JSON.parse(this.responseText || '{}');

            let json = {};
            if (/\/cart\/add(?:\.js)?(?:\?|$)/i.test(info.url || '')) {
              json = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(r => r.json());
            } else {
              json = JSON.parse(this.responseText || '{}');
            }

            // removeFromCart
            pushRemoveAsync(json);

            // addToCart
            try { await pushAddDeltaIfAny(__prevCartSnapshot, json); } catch(e){}
          } catch(e) {}
          __prevCartSnapshot = null; __deltaLock = false;
        });
      }

      return _send.apply(this, arguments);
    };

    if (!dl._origPush) {
      dl._origPush = dl.push.bind(dl);
  
      dl.push = function(evt){
        try {
          if (!evt || typeof evt !== 'object' || evt.__cart_augmented__) {
            return dl._origPush(evt);
          }
  
          if (evt.event === 'addToCart' && !evt.cart) {
            const base = JSON.parse(JSON.stringify(evt));
            base.__cart_augmented__ = true;
  
            getEnrichedCart().then(cartObj => {
              if (cartObj) {
                base.cart = cartObj;
              }
              return dl._origPush(base);
            }).catch(() => {
              dl._origPush(base);
            });

            return dl.length;
          }

          return dl._origPush(evt);
        } catch (e) {
          return dl._origPush(evt);
        }
      };
    }
  })();
});

// cutsom size add to cart button ends

// Function to synchronize select with input on page load
document.addEventListener('DOMContentLoaded', function () {
  const selectElement = document.querySelector('.custom_swatch');
  syncSelectAndInput();
  syncInputAndOption();
  selectDefaultBundle();

  function syncSelectAndInput() {
    const checkedInput = document.querySelector('#product-main-content input[name^="option-"]:checked');
    let matchingOption;
    if (checkedInput) {
      const selectedValue = checkedInput.value;
      matchingOption = selectElement.querySelector(`option[value="${selectedValue}"]`);
    }else{
      //product with only one size variant like "One Size" i.e. "Gingerbread Tote Brown" product
      matchingOption = document.querySelector('select[name="desk_size"] option[data-variant-fbid]');
      // console.log("matchingOption", matchingOption);
    }
    
    if (matchingOption) {
      matchingOption.selected = true;
      const variantId = matchingOption.getAttribute('data-variant-fbid');
      document.getElementById('sticky-variant-id-input').value = variantId;
      checkedInput?.setAttribute('data-variant-fbid', variantId);
      UpdatePreOrder(variantId);
      BackInStockWidgit_Init(variantId);
    }
  }

  function syncInputAndOption() {
    document.querySelectorAll('input[name^="option-"]').forEach((inputElement) => {
      inputElement.addEventListener('change', (event) => {
        const selectedValue = event.target.value;
        const matchingOption = selectElement.querySelector(`option[value="${selectedValue}"]`);
        if (matchingOption) {
          matchingOption.selected = true;
          const variantId = matchingOption.getAttribute('data-variant-fbid');
          document.getElementById('sticky-variant-id-input').value = variantId;
          event.target.setAttribute('data-variant-fbid', variantId);
          UpdatePreOrder(variantId);
          BackInStockWidgit_Init(variantId);
        }
      });
    });
  }

  function selectDefaultBundle() {
    const checkedInput = document.querySelector('#product-main-content input[name^="option-"]:checked');
    if (checkedInput) {
      const variantIdInput = document.getElementById('variant-id-input');
      variantIdInput.value = checkedInput?.dataset?.variantFbid;
    }
  }
});

// Add event listener for change event on select element
const selectElement = document.querySelector('select');
if (selectElement) {
  selectElement.addEventListener('change', (event) => {
    const selectedOption = event.target.selectedOptions[0];
    const selectedLabel = selectedOption.textContent.trim();
    let variantId =
      selectedOption.getAttribute('data-variant-fbid') ||
      selectedOption.parentElement.getAttribute('data-variant-fbid');
    const matchingDiv = document.querySelector(`.swatch-element[data-value="${selectedLabel}"]`);
    document.querySelectorAll('.swatch-element').forEach((swatchElement) => {
      swatchElement.setAttribute(
        'aria-checked',
        swatchElement.getAttribute('data-value') === selectedLabel ? 'true' : 'false'
      );
    });
    const inputElement = document.querySelector(`input[value="${selectedLabel}"]`);
    if (inputElement) {
      inputElement.checked = true;
      ['variant-id-input', 'sticky-variant-id-input'].forEach((id) => (document.getElementById(id).value = variantId));
      inputElement.setAttribute('data-variant-fbid', variantId);
      const priceContainer = document.querySelectorAll('.dynamic-price');
      const mf = window?.sm_theme?.variable?.money_format || '{{amount}}';
      const selectedVariant = window.productVariants.find((v) => v.id == variantId);
      const { name, price } = selectedVariant || {};
      if(name?.toLowerCase()?.includes('gift card') && mf)
        {
          let newPrice = Shopify.formatMoney(price, mf).replace('CAD', '').replace('.00', '');
          if (Shopify.country === 'GB') {
            newPrice = newPrice.replace('$', '');
          }
          priceContainer.forEach((price) => { price.innerHTML = newPrice });
        }
    }
  });
}

// Call sync functions on page load
// window.addEventListener('DOMContentLoaded', () => {
//   // syncSelectAndInput();
//   // syncInputAndOption();
// });

function syncPdpOptionAndInput() {
  const selectPdpElement = document.querySelector('select');
  if (selectPdpElement) {
    selectPdpElement.addEventListener('change', (event) => {
      const selectedPdpOption = event.target.selectedOptions[0];
      const selectedPdpLabel = selectedPdpOption.textContent.trim();
      let pdpVariantId =
        selectedPdpOption.getAttribute('data-variant-fbid') ||
        selectedPdpOption.parentElement.getAttribute('data-variant-fbid');
      const matchingPdpDiv = document.querySelector(`.swatch-element[data-value="${selectedPdpLabel}"]`);
      document.querySelectorAll('.swatch-element').forEach((pdpSwatchElement) => {
        pdpSwatchElement.setAttribute(
          'aria-checked',
          pdpSwatchElement.getAttribute('data-value') === selectedPdpLabel ? 'true' : 'false'
        );
      });
      const inputPdpElement = document.querySelector(`input[value="${selectedPdpLabel}"]`);
      if (inputPdpElement) {
        inputPdpElement.checked = true;
        ['pdp-variant-id-input', 'sticky-pdp-variant-id-input'].forEach(
          (id) => (document.getElementById(id).value = pdpVariantId)
        );
        inputPdpElement.setAttribute('data-variant-fbid', pdpVariantId);
      }
    });
  }
}

const isWomenShoe =()=>{
  let productData = undefined;
  try {
    productData = JSON?.parse(document.querySelector('[type="application/json"].currprod')?.textContent) || undefined;
  } catch (error) {
    return false;
  }
  if(!productData) return false;
  return productData?.tags?.includes("Category:Women's Shoes")
}

function syncPdpSelectAndInput() {
  const pdpSelectElement = document.querySelector('select[name="desk_size"]');
  const pdpInputElements = document.querySelectorAll('#product-main-content input[name^="option-"]');
  const pdpVariantIdInput = document.getElementById('variant-id-input');
  const stickyPdpVariantIdInput = document.getElementById('sticky-variant-id-input');
  const whishlistButton = document.getElementById('add-to-wishlist') || undefined;
  const defaultShoeSize = localStorage.getItem('defaultShoeSize') || (isWomenShoe() ? '6' : undefined)
  const swatchLabelElement = document.querySelector('.swatch .removeMargin');
  const isGiftCard = window.location.href.toLowerCase().includes('giftcard');
  if (pdpSelectElement) {
    pdpSelectElement.addEventListener('change', (event) => {
      const selectedOption = event.target.selectedOptions[0];
      const selectedValue = selectedOption.value;
      const variantId = selectedOption.getAttribute('data-variant-fbid');

      pdpInputElements.forEach((pdpInputElement) => {
        if (pdpInputElement.value === selectedValue) {
          pdpInputElement.checked = true;
          pdpInputElement.setAttribute('data-variant-fbid', variantId);
          pdpInputElement.setAttribute('value', selectedValue); // Pass the selected value
        } else {
          pdpInputElement.checked = false;
        }
      });

      pdpVariantIdInput.value = variantId; // Update variant ID input in add-to-cart form
      window.dataLayer.push({
        event: 'view_variant',
        variant_id: variantId,
        _clear: true,
      });
      if (whishlistButton) whishlistButton?.setAttribute('data-variant-id', variantId);
      UpdatePreOrder(variantId);
      BackInStockWidgit_Init(variantId);
      if(!isGiftCard)
        localStorage.setItem('defaultShoeSize', selectedValue);
      if (swatchLabelElement) {
        swatchLabelElement.textContent = `SIZE: `;
        const sizeSpan = document.createElement('span');
        sizeSpan.textContent = selectedValue;
        swatchLabelElement.appendChild(sizeSpan);
      }
    });
  }

  pdpInputElements.forEach((pdpInputElement) => {
    pdpInputElement.addEventListener('change', (event) => {
      const selectedValue = event.target.value;
      if (pdpSelectElement) {
        const matchingOption = pdpSelectElement.querySelector(`option[value="${selectedValue}"]`);
        if (matchingOption) {
          matchingOption.selected = true;
          const variantId = matchingOption.getAttribute('data-variant-fbid');
          console.log('We are changing the variant id HERE', variantId);
          pdpVariantIdInput.value = variantId;
          // Swym code starts here
          document.dispatchEvent(new CustomEvent('swym:variant-change', { detail: variantId }));
          // Swym code ends here
          // window.dataLayer.push({
          //   event: 'view_variant',
          //   variant_id: variantId,
          //   _clear: true,
          // });
          if (whishlistButton) whishlistButton?.setAttribute('data-variant-id', variantId);
          UpdatePreOrder(variantId);
          BackInStockWidgit_Init(variantId);
          if(isGiftCard) {
            const priceContainer = document.querySelectorAll('.dynamic-price');
            const mf = window?.sm_theme?.variable?.money_format;
            const selectedVariant = window.productVariants.find((v) => v.id == variantId);
            const { price } = selectedVariant;
            let newPrice = Shopify.formatMoney(price, mf).replace('CAD', '').replace('.00', '');
            if (Shopify.country === 'GB') {
              newPrice = newPrice.replace('$', '');
            }
            priceContainer.forEach((price) => { price.innerHTML = newPrice });
          }
          if(!isGiftCard)
            localStorage.setItem('defaultShoeSize', selectedValue);
          if (swatchLabelElement) {
            swatchLabelElement.textContent = `SIZE: `;
            const sizeSpan = document.createElement('span');
            sizeSpan.textContent = selectedValue;
            swatchLabelElement.appendChild(sizeSpan);
          }
        }
      }
    });
  });
  if (defaultShoeSize && !isGiftCard) {
    const matchingOption = Array.from(pdpInputElements).find((input) => input.value === defaultShoeSize);
    const selectMatchingOption = pdpSelectElement?.querySelector(`option[value="${defaultShoeSize}"]`);
    const isSoldOut = matchingOption?.parentElement?.classList.contains('soldout');
    if (pdpSelectElement) {
      if (matchingOption && !isSoldOut) {
        matchingOption.checked = true;
        selectMatchingOption.selected = true;
        const variantId = matchingOption?.parentElement?.getAttribute('data-variant-fbid');
        pdpVariantIdInput.value = variantId; // Update variant ID input in add-to-cart form
        stickyPdpVariantIdInput.value = variantId;
        // Swym code starts here
        document.dispatchEvent(new CustomEvent('swym:variant-change', { detail: variantId }));
        // Swym code ends here
        if (whishlistButton) whishlistButton?.setAttribute('data-variant-id', variantId);
        UpdatePreOrder(variantId);
        BackInStockWidgit_Init(variantId);
        if (swatchLabelElement) {
          swatchLabelElement.textContent = `SIZE: `;
          const sizeSpan = document.createElement('span');
          sizeSpan.textContent = defaultShoeSize;
          swatchLabelElement.appendChild(sizeSpan);
        }
      }
    }
  }
}

// Call sync function on page load
window.addEventListener('DOMContentLoaded', () => {
  syncPdpSelectAndInput();
});

// Form submission event
// const addToCartForm = document.getElementById('sticky-add-to-cart-form');
// if (addToCartForm) {
//   addToCartForm.addEventListener('submit', (event) => {
//     event.preventDefault();
//     const formData = new FormData(addToCartForm);
//     fetch(addToCartForm.action, {
//         method: addToCartForm.method,
//         body: formData
//       })
//       .then((response) =>
//         response.ok ?
//         sessionStorage.setItem('formSubmissionReload', 'true') || window.location.reload() :
//         console.error('Error:', response.statusText)
//       )
//       .catch((error) => console.error('Error:', error));
//   });
// }

// Page load event
window.addEventListener('load', () => {
  if (sessionStorage.getItem('formSubmissionReload') === 'true') {
    document.querySelector('cart-drawer').open();
    sessionStorage.removeItem('formSubmissionReload');
  }
});

// Function to update the Add to Cart button based on stock availability
function updateAddToCartButton() {
  var selectOptions = document.querySelectorAll('.select-styled option');
  var addToCartButton = document.getElementById('sticky-add-to-cart-btn');
  var variantIdInput = document.getElementById('sticky-variant-id-input');
  var selectedOption = document.querySelector('.select-styled option:checked');

  // Iterate through each option and disable those with data-stock="false"
  selectOptions.forEach(function (option) {
    if (option.dataset.stock === 'false') {
      option.disabled = true;
    } else {
      option.disabled = false;
    }
  });

  // Check if the currently selected option is disabled
  if (selectedOption && selectedOption.disabled) {
    // If the selected option is disabled, select the first enabled option
    var enabledOption = document.querySelector('.select-styled option:not([disabled])');
    if (enabledOption) {
      const selectedValue = enabledOption.value;
      enabledOption.selected = true;
      const swatchLabelElement = document.querySelector('.swatch .removeMargin');
      if (swatchLabelElement) {
        swatchLabelElement.textContent = selectedValue.toUpperCase();
      }
    }
  }

  // Update Add to Cart button state based on selected option
  if (selectedOption && selectedOption.dataset.stock === 'false') {
    addToCartButton.disabled = true;
    addToCartButton.textContent = 'Out of Stock';
  } else {
    if (addToCartButton) {
      addToCartButton.disabled = false;
      addToCartButton.textContent = 'Add to Cart';
    }
    if (variantIdInput) {
      variantIdInput.value = selectedOption ? selectedOption.dataset.variantFbid : ''; // Set variant ID for adding to cart
    }
  }
}

// Call the function initially to set button state
updateAddToCartButton();

// Add event listener to update button state when dropdown selection changes
var selectStyled = document.querySelector('.select-styled');
if (selectStyled) {
  selectStyled.addEventListener('change', updateAddToCartButton);
}

// cookie Consent JS

document.addEventListener('DOMContentLoaded', function () {
  // Function to set cookie value
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  // Function to get cookie value by name
  function getCookie(cname) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  // Select elements
  const banner = document.querySelector('.custom-onetrust-banner');
  const acceptBtn = document.getElementById('onetrust-accept-btn-handler');
  const cookiePopup = document.querySelector('.open-cookie-popup');
  const sdkBtn = document.getElementById('ot-sdk-btn');

  // Show banner if cookie is not set
  if (
    banner &&
    (typeof getCookie('oneturst-cookie') === 'undefined' ||
      getCookie('oneturst-cookie') === '' ||
      getCookie('oneturst-cookie') !== 'Done')
  ) {
    banner.style.display = 'block';
  }

  // Add event listener to accept button
  if (acceptBtn) {
    acceptBtn.addEventListener('click', function (e) {
      e.preventDefault();
      setCookie('oneturst-cookie', 'Done', 30);
      if (banner) {
        banner.style.display = 'none';
      }
    });
  }

  // Add event listener to cookie popup button
  if (cookiePopup) {
    cookiePopup.addEventListener('click', function (e) {
      e.preventDefault();
      sdkBtn.click();
    });
  }

  // Check URL for 'do-not-sell-my-personal-information' and trigger SDK button click if necessary
  const domain = window.location.hostname;
  if (domain === 'smdolcevita.myshopify.com') {
    if (window.location.href.indexOf('do-not-sell-my-personal-information') > -1) {
      if (localStorage.getItem('doo') === null) {
        setTimeout(function () {
          localStorage.setItem('doo', 'yes');
          if (sdkBtn) {
            sdkBtn.click();
          }
        }, 2500);
      }
    } else {
      localStorage.removeItem('doo');
    }
  }
  if (domain === 'www.stevemadden.com') {
    if (window.location.href.indexOf('do-not-sell-my-personal-data') > -1) {
      if (localStorage.getItem('doo') === null) {
        setTimeout(function () {
          localStorage.setItem('doo', 'yes');
          if (sdkBtn) {
            sdkBtn.click();
          }
        }, 2500);
      }
    } else {
      localStorage.removeItem('doo');
    }
  }
  if (domain === 'betseyjohnson.com') {
    if (window.location.href.indexOf('do-not-sell-my-personal-information') > -1) {
      if (localStorage.getItem('doo') === null) {
        setTimeout(function () {
          localStorage.setItem('doo', 'yes');
          if (sdkBtn) {
            sdkBtn.click();
          }
        }, 2500);
      }
    } else {
      localStorage.removeItem('doo');
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  updateStockStatus(); // Call the function to update the stock status on page load
});

function updateStockStatus() {
  var deskSize = document.querySelector('select[name="desk_size"]');
  const pdpVariantIdInput = document.getElementById('sticky-variant-id-input');
  var selectedOption = '';
  let selectedVariantId = '';
  if (deskSize) {
    selectedOption = deskSize.value;
    selectedVariantId = deskSize.options[deskSize.selectedIndex].getAttribute('data-variant-fbid');
    pdpVariantIdInput.value = selectedVariantId;
  }
  var button = document.getElementById('sticky-add-to-cart-btn');

  // Get the selected option's stock status
  var selectedOptionStock = document.querySelector('option[value="' + selectedOption + '"]');
  if (selectedOptionStock) {
    selectedOptionStock.getAttribute('data-stock');
  }

  // Update the button's disabled attribute based on stock status
  if (selectedOptionStock === 'true') {
    button.removeAttribute('disabled');
    button.textContent = 'Add to Cart';
  } else {
    if (button) {
      button.removeAttribute('disabled');
      // button.textContent = 'Out of Stock';
      UpdatePreOrder(selectedVariantId);
      BackInStockWidgit_Init(selectedVariantId);
    }
  }
}

// Event listener for select size change
var deskSize = document.querySelector('select[name="desk_size"]');
if (deskSize) {
  deskSize.addEventListener('change', function () {
    updateStockStatus();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const containers = document.querySelectorAll('.product_img_wp');
  containers.forEach((container) => {
    const image = container.querySelector('img');
    if (image) {
      const src = image.getAttribute('src');
      const newSrc = src.replace('_medium', ''); // Modifica según tu lógica
      image.setAttribute('src', newSrc);
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const links = document.querySelectorAll('.header__inline-menu a');

  links.forEach((link) => {
    if (link.textContent.trim() === 'ㅤ') {
      link.classList.add('mega-menu__link--hidden');
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const searchMainContainer = document.querySelector('.EzfyHeaderSearch.EzfyHeaderSearch--desktop');
  const searchContainer = document.querySelector('.EzfyHeaderSearch.EzfyHeaderSearch--desktop .search-container');
  const searchButton = document.querySelector('.EzfyHeaderSearch.EzfyHeaderSearch--desktop .search__button');
  const accountIcon = document.querySelector('.header__icon.header__icon--account');
  const smpassIcon = document.querySelector('.smpass-header');
  const wishlistIcon = document.querySelector('.wishlist_head_btn');
  const cartIcon = document.querySelector('.header__icon.header__icon--cart');
  const header = document.querySelector('.header-wrapper');
  const searchInput = searchContainer.querySelector('.search__input');

  const fixHeader = () => {
    if (window.scrollY > 0) {
      header.style.position = 'fixed';
      header.style.top = '0';
      header.style.left = '0';
      header.style.right = '0';
      header.style.zIndex = '1000';
      header.style.backgroundColor = '#fff';
    }
  };

  const revertHeader = () => {
    // accountIcon.style.display = '';
    // smpassIcon.style.display = '';
    // wishlistIcon.style.display = '';
    // cartIcon.style.display = '';

    header.style.position = '';
    header.style.top = '';
    header.style.left = '';
    header.style.zIndex = '';
    header.style.backgroundColor = '';
    header.style.boxShadow = '';
  };

  searchButton.addEventListener('click', () => {
    searchContainer.classList.toggle('active');
    searchMainContainer.classList.toggle('active');

    if (searchContainer.classList.contains('active')) {
      accountIcon.style.display = 'none';
      if (window.sm_pass_enabled) {
        smpassIcon.style.display = 'none';
      }
      if (window.wishlist_enabled) {
        wishlistIcon.style.display = 'none';
      }
      cartIcon.style.display = 'none';

      searchInput.focus();
      fixHeader();
    } else {
      accountIcon.style.display = '';
      if (window.sm_pass_enabled) {
        smpassIcon.style.display = '';
      }
      if (window.wishlist_enabled) {
        wishlistIcon.style.display = '';
      }
      cartIcon.style.display = '';
      revertHeader();
    }
  });

  const handleTyping = () => {
    if (window.scrollY > 0) {
      fixHeader();
    }
  };

  searchInput.addEventListener('keydown', handleTyping);
  searchInput.addEventListener('keyup', handleTyping);

  // document.addEventListener('click', (event) => {
  //   if (!searchMainContainer.contains(event.target)) {
  //     searchContainer.classList.remove('active');
  //     searchMainContainer.classList.remove('active');
  //     revertHeader();
  //   }
  // });

  window.addEventListener('scroll', () => {
    if (window.scrollY === 0 || !searchContainer.classList.contains('active')) {
      revertHeader();
    } else if (searchContainer.classList.contains('active')) {
      fixHeader();
    }
  });

  searchInput.addEventListener('blur', () => {
    if (!searchInput.value.trim()) {
      revertHeader();
    }
  });
});

document.querySelectorAll('section').forEach((section) => {
  const sliderComponent = section.querySelector('slider-component');
  if (sliderComponent) {
    const ulElement = sliderComponent.querySelector('ul');
    if (
      ulElement &&
      !ulElement.classList.contains('slider--tablet') &&
      ulElement.classList.contains('grid--1-col-tablet-down')
    ) {
      section.classList.add('cta-btn');
    }
  }
});

/* Script to handle scrolling to PDP reviews section */
document.addEventListener('DOMContentLoaded', function () {
  function attachClickListener() {
    var triggerElement = document.querySelector('.yotpo.bottomLine.yotpo-small');
    var targetElement = document.querySelector('.yotpo-reviews-main-widget');

    if (triggerElement && targetElement) {
      triggerElement.addEventListener('click', function () {
        var targetPosition = targetElement.getBoundingClientRect().top;

        if (window.innerWidth > 768) {
          var offsetPosition = targetPosition + window.scrollY - 200;
        } else {
          var offsetPosition = targetPosition + window.scrollY - 50;
        }

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      });

      observer.disconnect();
    }
  }

  var observer = new MutationObserver(attachClickListener);

  observer.observe(document.body, { childList: true, subtree: true });

  attachClickListener();
});

/* End script to handle scrolling to PDP reviews section */

document.addEventListener('DOMContentLoaded', (event) => {
  let pageDL = [];
  document.querySelectorAll('.image-banner-datalayer').forEach((section) => {
    let data = Object.assign({}, section.dataset);
    if (data.layer != '') {
      const promotion = JSON.parse(data.layer);
      pageDL.push({
        promotionName: promotion.data_layer_name,
        promotionId: promotion.data_layer_id,
        promotionCreativeName: promotion.data_layer_creative,
        promotionIndex: promotion.data_layer_index,
        promotionPosition: promotion.data_layer_position,
        promotionType: promotion.data_layer_type,
      });
    }
  });
  document
    .querySelectorAll('.__wrapper, .cta-to-datalayer, .offer-grid-left, .offer-grid-card, .offer_discount_sale .offer_discount, .join-sm-pass-block')
    .forEach((section) => {
      let promotion = Object.assign({}, section.dataset);
      promotion.promotionCreativeName = promotion.promotionCreative_name || '';
      delete promotion.promotionCreative_name;
      if (promotion.promotionId) {
        pageDL.push(promotion);
      }
    });
  if (pageDL.length !== 0) {
    window.dataLayer.push({
      event: 'view_promotion',
      promotions: pageDL,
      _clear: true,
    });
  }
  /* select_promotion event for deals page on CTA click*/
  document.querySelectorAll('.offer-grid-left, .offer-grid-card, .offer_discount_sale .offer_discount, .join-sm-pass-block').forEach((section) => {
    let promotion = Object.assign({}, section.dataset);
    promotion.promotionCreativeName = promotion.promotionCreative_name || '';
    delete promotion.promotionCreative_name;

    section.querySelectorAll('a').forEach((ctaElement) => {
      ctaElement.addEventListener('click', function (e) {
        e.preventDefault();
        const banner = {
          promotionName: promotion.promotionName,
          promotionId: promotion.promotionId,
          promotionCreativeName: promotion.promotionCreativeName,
          promotionPosition: promotion.promotionPosition,
          promotionIndex: promotion.promotionIndex,
          promotionType: promotion.promotionType,
          promotionButton: e.target.text.trim(),
        };
        window.dataLayer.push({
          event: 'select_promotion',
          promotions: banner,
          _clear: true,
        });
        window.location.href = e.target.href;
      });
    });
  });
});

/* Glossary page*/
$(document).ready(function () {
  $('.head-links a').click(function () {
    if (!$(this).hasClass('inactive-link') && !$(this).hasClass('selected')) {
      $('.head-links a').each(function () {
        $(this).removeClass('selected');
      });

      $(this).addClass('selected');

      var y = $(this).attr('id');

      if ($(this).hasClass('all')) {
        $('.toggle-item').each(function () {
          if (!$(this).hasClass('inactive')) {
            $(this).css('display', 'block');
          }
        });
        $('.back-to-top').css('display', 'inline');
      } else {
        $('.back-to-top').css('display', 'none');
        $('.toggle-item').each(function () {
          if ($(this).hasClass('toggle-item-' + y)) {
            $(this).css('display', 'block');
          } else {
            $(this).css('display', 'none');
          }
        });
      }
    }
    return false;
  });

  $('.back-to-top a').click(function () {
    var targetOffset = $('#cachedTC_TCArea_1').offset().top;
    var scrollTopValue;

    if (window.innerWidth > 768) {
      scrollTopValue = targetOffset - 100;
    } else {
      scrollTopValue = targetOffset - 50;
    }

    $('html, body').animate(
      {
        scrollTop: scrollTopValue,
      },
      500
    );
  });
});
/* End Glossary Page*/

/* Re-Booted Page*/
document.querySelectorAll('.sm-faq-section .accordion-container .set h3 span').forEach((item) => {
  item.addEventListener('click', () => {
    const content = item.parentElement.nextElementSibling;

    content.style.display = content.style.display === 'block' ? 'none' : 'block';

    item.parentElement.classList.toggle('active');
  });
});
/* End Re-Booted Page*/

/* Rewards Page */
document.querySelectorAll('.yotpo_faq_secton .accordion-container .set h3 button').forEach((button) => {
  button.addEventListener('click', () => {
    const content = button.parentElement.nextElementSibling;
    const isExpanded = button.getAttribute('aria-expanded') === 'true';

    content.style.display = isExpanded ? 'none' : 'block';

    button.setAttribute('aria-expanded', !isExpanded);

    button.parentElement.classList.toggle('active');
  });
});
/* End Rewards Page */

/* SM Squad Page */
$(document).ready(function () {
  $('.cm_faq_title').click(function () {
    $('.faq_item_content').slideUp();
    $('.cm_faq_title').removeClass('active');
    $('.cm_faq_title button').attr('aria-expanded', 'false');

    if (!$(this).next('.faq_item_content').is(':visible')) {
      $(this).addClass('active');
      $(this).find('button').attr('aria-expanded', 'true');
      $(this).next('.faq_item_content').slideDown();
    }
  });
  function wishlist_load() {
    if ($('.wishlist_mini .swym-loaded').length > 0) {
      $('.wishlist_mini .swym-loaded').css('visibility', 'visible');
    } else {
      setTimeout(function () {
        wishlist_load();
      }, 2000);
    }
  }
});
document.querySelectorAll('.cm_sq_input input, .cm_sq_input textarea').forEach((input) => {
  input.addEventListener('input', () => {
    if (input.value.trim() !== '') {
      input.classList.add('has-content');
    } else {
      input.classList.remove('has-content');
    }
  });
});
/* End SM Squad Page */

/* Returns Page */
if (window.location.pathname.includes('/pages/returns')) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const reshopReturn = document.querySelector('reshop-return');
        if (reshopReturn && reshopReturn.shadowRoot) {
          const shadowRoot = reshopReturn.shadowRoot;
          const textIncentive = shadowRoot.querySelector('.text-incentive-container .bodySmallBold.text-incentive');
          const headerBold = shadowRoot.querySelector('.headerBold');
          const bodyDefault = shadowRoot.querySelector('.bodyDefault.content');
          const bulletImages = shadowRoot.querySelectorAll('.bullet-container img');
          const bulletSpan = shadowRoot.querySelectorAll('.bullet-container span');
          const reshopButton = shadowRoot.querySelector('.button-container p');
          if (textIncentive) {
            textIncentive.classList.add('reshop-badge');
            headerBold.classList.add('reshop-title');
            bodyDefault.classList.add('reshop-p');
            reshopButton.classList.add('reshop-button');
            bulletImages.forEach((img) => {
              img.classList.add('reshop-img');
            });
            bulletSpan.forEach((span) => {
              span.classList.add('reshop-span');
            });
            const shadowStyle = document.createElement('style');
            shadowStyle.textContent = `
                .bodySmallBold.text-incentive.reshop-badge {
                  font-size: 14px;
                  padding: 8px;
                }
                .headerBold.reshop-title {
                  font-size: 24px;
                  line-height: 32px;
                }
                .bodyDefault.content.reshop-p {
                  font-size: 16px;
                  line-height: 24px;
                }
                img.reshop-img {
                  height: 25px !important;
                  width: 25px !important;
                }
                span.reshop-span {
                  font-size: 16px;
                  line-height: 24px;
                }
                .button-container {
                  height: 50px !important;
                  min-width: fit-content !important;
                  width: 100% !important;
                }
                .button-container .bodyBold.reshop-button {
                  font-size: 16px;
                  width: 320px;
                }
                @media (max-width: 480px) {
                  .button-container .bodyBold.reshop-button {
                    width: 250px;
                  }
                }
                reshop-tooltip {
                  height: 24px !important;
                  width: 70px !important;
                }
              `;
            shadowRoot.appendChild(shadowStyle);
            observer.disconnect();
          }
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}
/* End Returns Page*/
var wishlistButton = document.querySelectorAll('.swym-add-to-wishlist_custom');

for (var i = 0; i < wishlistButton.length; i++) {
  wishlistButton[i].addEventListener('click', function (event) {
    if ($(this).hasClass('swym-added')) {
      return true;
    }
    if (window?.sm_theme?.variable.not_customer == true) {
      $.ajax({
        url: 'https://services.stevemadden.com/SwellWebhook/GetWishlist',
        data: { email: window.sm_theme.variable.customer_id, customer_id: window.sm_theme.variable.customer_id },
        type: 'POST',
        success: function (result) {},
        error: function (result) {},
      });
    }
  });
}

function wishlist_load() {
  if ($('.wishlist_mini .swym-loaded').length > 0) {
    $('.wishlist_mini .swym-loaded').css('visibility', 'visible');
  } else {
    setTimeout(function () {
      wishlist_load();
    }, 2000);
  }
}

if (window.enabled_max_units) {
  // console.log("SMRDTC-308 Initial", window.order_count);
  setOrderCount(window.order_count);

  document.addEventListener('DOMContentLoaded', function () {
    const spanCta = document.querySelector('.initial-count-units-cta');

    const modal = document.querySelector('.product_quickview');
    if (modal) {
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          const addToCartQuickButton = document.querySelector('.addtocart.quickAdd');
          if (addToCartQuickButton && !addToCartQuickButton.hasAttribute('data-click-attached')) {
            addToCartQuickButton.setAttribute('data-click-attached', 'true');
            addToCartQuickButton.addEventListener('click', function (event) {
              // console.log("SMRDTC-308 quickadd ele:", spanCta);
              const spanQuickCta = document.querySelector('.initial-count-units-cta');
              if (!validateOrderCount(spanQuickCta)) {
                event.preventDefault();
                event.stopPropagation();
              }
            });
          }
        });
      });
      observer.observe(modal, { childList: true, subtree: true });
    }

    const addToCartSticky = document.querySelector('#sticky-add-to-cart-btn');
    if (addToCartSticky) {
      addToCartSticky.addEventListener('click', function (event) {
        // console.log("SMRDTC-308 sticky ele", spanCta);
        if (!validateOrderCount(spanCta)) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    }

    const addToCartMob = document.querySelector('#addToCartBtn');
    if (addToCartMob) {
      addToCartMob.addEventListener('click', function (event) {
        // console.log("SMRDTC-308 pdp ele", spanCta);
        if (!validateOrderCount(spanCta)) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    }

    document.addEventListener('click', function (event) {
      const spanCta = document.querySelector('.initial-count-units-cta');
      const spanCart = document.querySelector('.initial-count-units-cart');
      const spanDrawer = document.querySelector('.initial-count-units-drawer');

      if (event.target.matches('.quantity__button[name="minus"]')) {
        if (window.order_count > 0 && !event.target.classList.contains('disabled')) {
          if (spanCart) {
            spanCart.style.display = 'none';
          }
          if (spanCta) {
            spanCta.style.display = 'none';
          }
          if (spanDrawer) {
            spanDrawer.style.display = 'none';
            localStorage.removeItem('spanDrawerVisible');
          }
        }
      } else if (event.target.matches('.quantity__button[name="plus"]')) {
        // console.log("SMRDTC-308 plus ele", spanCta);
        // console.log("SMRDTC-308 plus ele", spanDrawer);
        if ((spanCta && !validateOrderCount(spanCta)) || (spanDrawer && !validateOrderCount(spanDrawer))) {
          event.preventDefault();
          event.stopPropagation();
          const quantityInput = event.target.closest('.quantity').querySelector('.quantity__input');
          quantityInput.value = parseInt(quantityInput.value) - 1;

          if (spanCart) {
            spanCart.style.display = 'block';
          }
          if (spanCta) {
            spanCta.style.display = 'block';
          }
          if (spanDrawer) {
            spanDrawer.style.display = 'block';
            localStorage.setItem('spanDrawerVisible', 'true');
          }
        }
      } else if (event.target.matches('.cart-remove-button')) {
        if (spanCart) {
          spanCart.style.display = 'none';
        }
        if (spanCta) {
          spanCta.style.display = 'none';
        }
        if (spanDrawer) {
          spanDrawer.style.display = 'none';
          localStorage.removeItem('spanDrawerVisible');
        }
        const quantityInput = event.target.closest('.cart-item').querySelector('.quantity__input');
        const quantityToRemove = parseInt(quantityInput.value);
        let currentOrderCount = getOrderCount();
        // console.log("SMRDTC-308 removed:", (currentOrderCount - quantityToRemove));
        setOrderCount(currentOrderCount - quantityToRemove);
      } else if (event.target.matches('.button.button--tertiary, .button.button--tertiary *')) {
        if (spanCart) {
          spanCart.style.display = 'none';
        }
        if (spanCta) {
          spanCta.style.display = 'none';
        }
        if (spanDrawer) {
          spanDrawer.style.display = 'none';
          localStorage.removeItem('spanDrawerVisible');
        }
        const cartItem = event.target.closest('.cart-item');
        if (cartItem) {
          const quantityInput = cartItem.querySelector('.quantity__input');
          const quantityToRemove = parseInt(quantityInput.value);

          let currentOrderCount = getOrderCount();
          // console.log("SMRDTC-308 unknown:", (currentOrderCount + 1));
          setOrderCount(currentOrderCount - quantityToRemove);
        }
      }
    });
  });

  const cartDrawer = document.querySelector('#CartDrawer');
  if (cartDrawer) {
    const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          if (localStorage.getItem('spanDrawerVisible') === 'true') {
            const spanDrawer = document.querySelector('.initial-count-units-drawer');
            if (spanDrawer) {
              spanDrawer.style.display = 'block';
            }
          }
        }
      }
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true,
    });
  }
}

/* Prevent adding more than 10 items per order in the input */
if (window.enabled_max_units) {
  document.addEventListener(
    'focus',
    function (event) {
      if (event.target.matches('.quantity__input')) {
        const quantityInput = event.target;
        localStorage.setItem(`originalQuantity`, quantityInput.value);
        const spanCart = document.querySelector('.initial-count-units-cart');
        const spanDrawer = document.querySelector('.initial-count-units-drawer');
        if (spanCart) {
          spanCart.style.display = 'none';
        }
        if (spanDrawer) {
          spanDrawer.style.display = 'none';
          localStorage.removeItem('spanDrawerVisible');
        }
      }
    },
    true
  );

  document.addEventListener(
    'blur',
    function (event) {
      if (event.target.matches('.quantity__input')) {
        const quantityInput = event.target;
        const currentQuantity = parseInt(quantityInput.value) || 0;
        const originalQuantity = parseInt(localStorage.getItem('originalQuantity')) || 0;
        const totalQuantity = window.order_count + (currentQuantity - originalQuantity);

        if (totalQuantity > 10) {
          const validQuantity = 10 - (window.order_count - originalQuantity);
          quantityInput.value = validQuantity;

          const spanDrawer = document.querySelector('.initial-count-units-drawer');
          const spanCart = document.querySelector('.initial-count-units-cart');
          if (spanDrawer) {
            spanDrawer.style.display = 'block';
            localStorage.setItem('spanDrawerVisible', 'true');
          }
          if (spanCart) {
            spanCart.style.display = 'block';
          }
          // console.log("SMRDTC-308 blur fixed:", 10);
          setOrderCount(10);
        }
        localStorage.removeItem(`originalQuantity`);
      }
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.target.matches('.quantity__input') && event.key === 'Enter') {
        event.preventDefault();

        const quantityInput = event.target;
        const currentQuantity = parseInt(quantityInput.value) || 0;
        const originalQuantity = parseInt(localStorage.getItem('originalQuantity')) || 0;
        const totalQuantity = window.order_count + (currentQuantity - originalQuantity);

        if (totalQuantity > 10) {
          const validQuantity = 10 - (window.order_count - originalQuantity);
          quantityInput.value = validQuantity;

          const spanDrawer = document.querySelector('.initial-count-units-drawer');
          const spanCart = document.querySelector('.initial-count-units-cart');
          if (spanDrawer) {
            spanDrawer.style.display = 'block';
            localStorage.setItem('spanDrawerVisible', 'true');
          }
          if (spanCart) {
            spanCart.style.display = 'block';
          }
          console.log("SMRDTC-308 down fixed:", 10);
          setOrderCount(10);
        }
        if (event.target.form) {
          event.target.form.submit();
        }
      }
    },
    true
  );
}
if (window.enabled_max_units) {
  const debounceClick = (button, delay = 200) => {
    if (button.disabled) return;
    button.disabled = true;
    setTimeout(() => {
      button.disabled = false;
    }, delay);
  };

  document.addEventListener('click', function (event) {
    const btn = event.target.closest('.quantity__button');
    if (btn) {
      debounceClick(btn, 300);
    }
  });
}
/* End prevent adding more than 10 items per order in the input */
if (window.location.pathname.includes('/pages/rewards')) {
  document.addEventListener('DOMContentLoaded', function () {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length) {
          var all_rows_0 = document.querySelectorAll(
            '.yotpo-grid-vip-tier-container:nth-child(2) .yotpo-vip-tiers-grid-benefit-status'
          );
          var all_rows_1 = document.querySelectorAll(
            '.yotpo-grid-vip-tier-container:nth-child(3) .yotpo-vip-tiers-grid-benefit-status'
          );
          var all_rows_2 = document.querySelectorAll(
            '.yotpo-grid-vip-tier-container:nth-child(4) .yotpo-vip-tiers-grid-benefit-status'
          );
          var all_rows_3 = document.querySelectorAll(
            '.yotpo-grid-vip-tier-container:nth-child(5) .yotpo-vip-tiers-grid-benefit-status'
          );
          all_rows_0.forEach(function (row) {
            var svgElement = row.querySelector('svg');
            if (svgElement) {
              svgElement.outerHTML =
                "<img src='https://cdn.shopify.com/s/files/1/2170/8465/files/ORANGE_STAR_1e7306fe-2a3b-47ed-870e-7a14908acf83.png?v=1683519258' alt='Star Icon'>";
            }
          });
          all_rows_1.forEach(function (row) {
            var svgElement = row.querySelector('svg');
            if (svgElement) {
              svgElement.outerHTML =
                "<img src='https://cdn.shopify.com/s/files/1/2170/8465/files/ORANGE_STAR_1e7306fe-2a3b-47ed-870e-7a14908acf83.png?v=1683519258' alt='Star Icon'>";
            }
          });
          all_rows_2.forEach(function (row) {
            var svgElement = row.querySelector('svg');
            if (svgElement) {
              svgElement.outerHTML =
                "<img src='https://cdn.shopify.com/s/files/1/2170/8465/files/GREEN_STAR_9980a43e-9e99-4bb3-b279-f545c206c0c0.png?v=1683519258' alt='Star Icon'>";
            }
          });
          all_rows_3.forEach(function (row) {
            var svgElement = row.querySelector('svg');
            if (svgElement) {
              svgElement.outerHTML =
                "<img src='https://cdn.shopify.com/s/files/1/2170/8465/files/BLUE_STAR_cfde5154-e288-47a2-9ee5-0a38cfb06b43.png?v=1683519258' alt='Star Icon'>";
            }
          });
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
}

/* Footer: Prevent label from returning to its original position when it has content */
document.querySelectorAll('.newsletter-form__field-wrapper .field input').forEach((input) => {
  input.addEventListener('input', () => {
    if (input.value.trim() !== '') {
      input.classList.add('has-content');
    } else {
      input.classList.remove('has-content');
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {

  /* Add a class for custom klaviyo */
  if (window.klaviyo_custom_newsletter) {
    const footerNewsletter = document.querySelector('.footer__content-top .footer__blocks-wrapper > .footer-block:last-child');
    if (footerNewsletter) {
      footerNewsletter.classList.add('custom-klaviyo-newsletter');
    }
  }

  /* Add a class to move Klaviyo newsletter to an upper position */
  if (window.klaviyo_upper_position) {
    const footerNewsletter = document.querySelector('.footer__content-top .footer__blocks-wrapper > .footer-block:last-child');
    if (footerNewsletter) {
      footerNewsletter.classList.add('klaviyo-upper-position');
    }
  }

  /* Logic for custom Klaviyo newsletter checkbox */
  if (window.klaviyo_checkbox) {
    function attachCheckboxValidation() {
      const form = document.querySelector('form.klaviyo-form');
      const submitButton = form?.querySelector('button[type="button"]');
      const termsCheckbox = document.querySelector('.hidden-checkbox');
      const errorMessage = document.getElementById('termsErrorMessage');
      const emailInput = form?.querySelector('input[type="email"]');

      if (!form || !submitButton || !termsCheckbox || !errorMessage || !emailInput) {
        return;
      }

      if (form.dataset.validationAttached === 'true') {
        return;
      }
      form.dataset.validationAttached = 'true';

      // Create the overlay dynamically and wrap the button
      const buttonWrapper = document.createElement('div');
      buttonWrapper.style.position = 'relative';
      buttonWrapper.style.display = 'contents';

      const overlay = document.createElement('div');
      overlay.style.position = 'absolute';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.right = '0';
      overlay.style.bottom = '0';
      overlay.style.background = 'transparent';
      overlay.style.cursor = 'pointer';
      overlay.style.display = 'none';

      // Insert the button inside the wrapper and add the overlay
      submitButton.parentNode.insertBefore(buttonWrapper, submitButton);
      buttonWrapper.appendChild(submitButton);
      buttonWrapper.appendChild(overlay);

      // Initially disabled
      submitButton.disabled = true;
      overlay.style.display = 'block';

      // Change the state based on the checkbox
      termsCheckbox.addEventListener('change', function () {
        if (termsCheckbox.checked && emailInput.value.trim() !== '') {
          submitButton.disabled = false;
          submitButton.classList.remove('disabled-button');
          overlay.style.display = 'none';
          errorMessage.style.display = 'none';
        } else {
          submitButton.disabled = true;
          submitButton.classList.add('disabled-button');
          overlay.style.display = 'block';
        }
      });

      // Capture the click on the overlay (when it is visible)
      overlay.addEventListener('click', function () {
        if (emailInput.value.trim() !== '') {
          errorMessage.style.display = 'block';
        }
      });

      // Final validation in case someone presses Enter
      form.addEventListener('submit', function (e) {
        if (!termsCheckbox.checked) {
          e.preventDefault();
          errorMessage.style.display = 'block';
        }
      });

      // Prevent Enter from submitting the form if conditions are not met
      form.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          if (submitButton.disabled) {
            e.preventDefault();
            if(!termsCheckbox.checked && emailInput.value.trim() !== ''){
              errorMessage.style.display = 'block';
            }
          }
        }
      });

    }

    // Observer to wait for the form to load
    const observer = new MutationObserver(function () {
      const form = document.querySelector('form.klaviyo-form');
      if (form) {
        attachCheckboxValidation();
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
})

const cartLink = document.querySelector('#cart-icon-bubble');
cartLink.addEventListener('click', (event) => {
  event.preventDefault();
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'viewedSideCart',
    _clear: true,
  });
});

document.querySelectorAll('.swatch label').forEach((swatch) => {
  swatch.addEventListener('click', () => {
    const variantId = swatch.parentElement.getAttribute('data-variant-fbid');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'view_variant',
      variant_id: variantId,
      _clear: true,
    });
  });
});

const targetImage = document.querySelector('img[alt="Headcount"]');

if (targetImage) {
  const parentSection = targetImage.closest('.shopify-section.section');
  if (parentSection) {
    parentSection.style.marginTop = '15px';
  }
}

window.addEventListener('load', function () {
  const observer = new MutationObserver(function () {
    const squarePlacementElement = document.querySelector('square-placement');
    if (squarePlacementElement && squarePlacementElement.shadowRoot) {
      const shadowRoot = squarePlacementElement.shadowRoot;
      const slotElement = shadowRoot.querySelector('slot');
      const buttonElement = shadowRoot.querySelector('.afterpay-link');
      if (slotElement) {
        slotElement.style.fontWeight = '900';
        observer.disconnect();
      }
      if (buttonElement) {
        buttonElement.style.fontSize = '14px';
        observer.disconnect();
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
});

/* SM Squad Page */
$(document).ready(function () {
  var cnt_yotpo_fimd = 0;
  function yotpo_refferal_page_title() {
    cnt_yotpo_fimd++;
    if (cnt_yotpo_fimd > 20) {
      return false;
    }
    if ($('.yotpo-widget-instance-container[yotpo-instance-id="18278"] .yotpo-title').length > 0) {
      if ($('.yotpo-logged-in-customer').length)
        $('.yotpo-widget-instance-container[yotpo-instance-id="18278"] .yotpo-title').html(
          "<img src='https://cdn.shopify.com/s/files/1/2170/8465/files/LOGO_ON_WHITE_fca4eb23-117e-48ff-9180-16c8855258ef_300x.png?v=1647854305' alt='' class='yotpo_title_image'>"
        );
      else
        $('.yotpo-widget-instance-container[yotpo-instance-id="18278"] .yotpo-title').html(
          "<img src='https://cdn.shopify.com/s/files/1/2170/8465/files/imgpsh_fullsize_anim.png?v=1646993105' alt='' class='yotpo_title_image'>"
        );
      return;
    } else {
      setTimeout(function () {
        yotpo_refferal_page_title();
      }, 500);
    }
  }

  yotpo_refferal_page_title();
});

document.addEventListener('DOMContentLoaded', function () {
  const contentWrapper = document.querySelector('.colorTag fieldset.swatch-wrapper');
  const scrollbarThumb = document.querySelector('.custom-scrollbar-thumb');

  function checkOverflow() {
    if (contentWrapper) {
      const scrollWidth = contentWrapper.scrollWidth;
      const clientWidth = contentWrapper.clientWidth;

      if (scrollbarThumb?.parentElement) {
        if (scrollWidth > clientWidth || clientWidth < 749) {
          scrollbarThumb.parentElement.style.display = 'contents';
          updateScrollbar();
        } else {
          scrollbarThumb.parentElement.style.display = 'none';
        }
      }
    }
  }

  function updateScrollbar() {
    const scrollWidth = contentWrapper.scrollWidth;
    const clientWidth = contentWrapper.clientWidth;
    const scrollLeft = contentWrapper.scrollLeft;

    const thumbWidth = (clientWidth / scrollWidth) * clientWidth;
    const thumbLeft = (scrollLeft / scrollWidth) * clientWidth;

    scrollbarThumb.style.width = `${thumbWidth}px`;
    scrollbarThumb.style.left = `${thumbLeft + 30}px`;
  }

  checkOverflow();
  if (contentWrapper) {
    contentWrapper.addEventListener('scroll', updateScrollbar);
  }
  window.addEventListener('resize', checkOverflow);
});

// $('body').on('click', '.close-quick, .overlay, .btn.addtocart.quickAdd', function (e) {
//   var getProductData = JSON.parse($('.product_quickview').find('[type="application/json"].quick').text());
//   $('.product_quickview, .overlay').removeClass('active');
//   $('body').removeClass('Fixed');
//   window.dataLayer = window.dataLayer || [];
//   window.dataLayer.push({
//     event: 'quick_view_close',
//     quickviewProduct: getProductData,
//     _clear: true,
//   });
// });

window.addEventListener('DOMContentLoaded', function () {
  var ctaGroups = document.querySelectorAll('.multi-column-cta-group');

  function adjustLayout(ctaGroup) {
    var childCount = ctaGroup.children.length;
    var isMobile = window.innerWidth <= 750;

    if (isMobile) {
      ctaGroup.querySelectorAll('a').forEach((item, index) => {
        item.style.flex = '0 0 100%';

        if (childCount % 2 !== 0 && index === childCount - 1) {
          item.style.margin = '8px';
        } else {
          item.style.margin = '8px auto';
        }
      });
    } else {
      if (childCount <= 4) {
        ctaGroup.querySelectorAll('a').forEach((item) => {
          item.style.flex = `0 0 calc(${100 / childCount}% - 20px)`;
        });
      } else if (childCount === 5) {
        ctaGroup.querySelectorAll('a').forEach((item, index) => {
          item.style.flex = '0 0 calc(33.33% - 20px)';
        });
      } else if (childCount === 6) {
        ctaGroup.querySelectorAll('a').forEach((item) => {
          item.style.flex = '0 0 calc(33.33% - 20px)';
        });
      } else if (childCount === 7) {
        ctaGroup.querySelectorAll('a').forEach((item, index) => {
          item.style.flex = '0 0 calc(25% - 20px)';
        });
      } else if (childCount > 7) {
        ctaGroup.querySelectorAll('a').forEach((item) => {
          item.style.flex = '0 0 calc(25% - 20px)';
        });
      }
    }
  }

  ctaGroups.forEach((ctaGroup) => {
    adjustLayout(ctaGroup);
  });

  window.addEventListener('resize', () => {
    ctaGroups.forEach((ctaGroup) => {
      adjustLayout(ctaGroup);
    });
  });

  setTimeout(function () {
    ctaGroups.forEach((ctaGroup) => {
      ctaGroup.classList.remove('hidden-cta');
      ctaGroup.classList.add('show-cta');
    });
  }, 500);
});

window.addEventListener('DOMContentLoaded', function () {
  var ctaGroups = document.querySelectorAll('.collection-hero__text-wrapper .multi-column-cta-group');

  function adjustLayout(ctaGroup) {
    var childCount = ctaGroup.children.length;
    var isMobile = window.innerWidth <= 750;

    if (isMobile) {
      ctaGroup.querySelectorAll('a').forEach((item, index) => {
        item.style.flex = '0 0 calc(50% - 16px)';

        if (childCount % 2 !== 0 && index === childCount - 1) {
          item.style.margin = '8px';
        } else {
          item.style.margin = '8px auto';
        }
      });
    } else {
      if (childCount <= 4) {
        ctaGroup.querySelectorAll('a').forEach((item) => {
          item.style.flex = `0 0 calc(${100 / childCount}% - 20px)`;
        });
      } else if (childCount === 5) {
        ctaGroup.querySelectorAll('a').forEach((item, index) => {
          if (index < 3) {
          } else {
            item.style.flex = '0 0 calc(33.33% - 20px)';
          }
        });
      } else if (childCount === 6) {
        ctaGroup.querySelectorAll('a').forEach((item) => {
          item.style.flex = '0 0 calc(33.33% - 20px)';
        });
      } else if (childCount === 7) {
        ctaGroup.querySelectorAll('a').forEach((item, index) => {
          if (index < 4) {
            item.style.flex = '0 0 calc(25% - 20px)';
          } else {
            item.style.flex = '0 0 calc(25% - 20px)';
          }
        });
      } else if (childCount > 7) {
        ctaGroup.querySelectorAll('a').forEach((item) => {
          item.style.flex = '0 0 calc(25% - 20px)';
        });
      }
    }
  }

  ctaGroups.forEach((ctaGroup) => {
    adjustLayout(ctaGroup);
  });

  window.addEventListener('resize', () => {
    ctaGroups.forEach((ctaGroup) => {
      adjustLayout(ctaGroup);
    });
  });

  setTimeout(function () {
    ctaGroups.forEach((ctaGroup) => {
      ctaGroup.classList.remove('hidden-cta');
      ctaGroup.classList.add('show-cta');
    });
  }, 500);
});

$('body').on('click', '.close-modal.care', function (e) {
  $('.care_modal').removeClass('open');
});

$('body').on('click', 'a.view_care', function (e) {
  $('.care_modal').addClass('open');
});

$('body').on('click', '.zip-wrapper .zip-link', function (e) {
  e.preventDefault();
  $('.zip-learn-more:first').trigger('click');
});
